'use client';
import React, { useEffect, useState } from 'react';

import env from 'src/env';
import GoogleReCaptchaProvider from './GoogleReCaptchaProvider';

export function GoogleCaptchaWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const recaptchaKey: string | undefined =
    env.googleReCaptcha || '6Lf2f3wqAAAAAL0ombxi851q30Q5OZ1SikGoDVfP';
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  useEffect(() => {
    // Check if the reCAPTCHA script is already loaded
    if (typeof window !== 'undefined' && (window as any).grecaptcha) {
      setIsScriptLoaded(true);
      return;
    }

    // If not loaded, monitor for script loading
    const checkScriptLoaded = setInterval(() => {
      if (typeof window !== 'undefined' && (window as any).grecaptcha) {
        setIsScriptLoaded(true);
        clearInterval(checkScriptLoaded);
      }
    }, 100);

    // Clean up interval
    return () => clearInterval(checkScriptLoaded);
  }, []);

  // Log warning if key is missing
  useEffect(() => {
    if (!recaptchaKey || recaptchaKey === 'NOT DEFINED') {
      console.error(
        'Google reCAPTCHA key is missing or invalid. Forms requiring reCAPTCHA validation will not work.',
      );
    }
  }, [recaptchaKey]);

  return (
    <GoogleReCaptchaProvider
      scriptProps={{
        async: false, // Changed to false to ensure script loads before use
        defer: false, // Changed to false to ensure script loads before use
        appendTo: 'head', // Ensure script is added to head for earlier loading
      }}
      reCaptchaKey={recaptchaKey ?? 'NOT DEFINED'}
      language="en"
    >
      {children}
    </GoogleReCaptchaProvider>
  );
}
